import { IPackageType } from "../types";

interface ISwitcherProps {
  packageType: IPackageType;
  setPackageType: (packageType: IPackageType) => void;
  testId?: string;
}

export function Switcher({
  packageType,
  setPackageType,
  testId,
}: ISwitcherProps) {
  return (
    <form>
      <div
        className="bg-porcelain border-2 border-white border-solid p-[4px] rounded-badge flex gap-2 z-up"
        data-cy={testId}
      >
        {/* DON'T DELETE DIV! It's required for proper working switch */}
        <div className="block flex-1">
          <input
            checked={packageType === "PROMO"}
            className="peer absolute h-[1px] w-[1px] border-0 overflow-hidden"
            id="PROMO"
            name="PROMO"
            onChange={() => {
              setPackageType("PROMO");
            }}
            type="radio"
            value="PROMO"
          />
          <label
            className="
              peer-checked:text-white peer-checked:bg-cerulean transition duration-150 ease-out hover:ease-in
              rounded-badge min-h-[32px] flex items-center justify-center text-center px-4 cursor-pointer
              hover:text-white hover:bg-cerulean text-size-12
            "
            htmlFor="PROMO"
          >
            oferta promocyjna
          </label>
        </div>
        {/* DON'T DELETE DIV! It's required for proper working switch */}
        <div className="block flex-1">
          <input
            checked={packageType === "STANDARD"}
            className="peer absolute h-[1px] w-[1px] border-0 overflow-hidden"
            id="STANDARD"
            name="STANDARD"
            onChange={() => {
              setPackageType("STANDARD");
            }}
            type="radio"
            value="STANDARD"
          />
          <label
            className="
              peer-checked:text-white peer-checked:bg-cerulean transition duration-150 ease-out hover:ease-in
              rounded-badge min-h-[32px] flex items-center justify-center text-center px-4 cursor-pointer
              hover:text-white hover:bg-cerulean text-size-12
            "
            htmlFor="STANDARD"
          >
            oferta podstawowa
          </label>
        </div>
      </div>
    </form>
  );
}
